/* ns-motion-core — reveal-on-scroll engine for [data-ns-motion] and [data-ns-motion-stagger].
   Exposes window.NSMotion = { observe(root), reveal(el), reduced } for page-level motion files.

   Reveal integrity rules this file has to hold:
   - threshold is 0, not a ratio: an element carrying a zero/near-zero-area
     clip-path reports an almost empty intersection rect, so any ratio gate
     would never fire for the clip-* primitives.
   - a rAF-throttled scroll/resize sweep reveals anything the viewport has
     already reached or passed, so an instant scroll jump (in-page anchor,
     scroll restoration on back-navigation, "back to top") cannot strand a
     section at opacity 0. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  var SELECTOR = '[data-ns-motion], [data-ns-motion-stagger]';
  var MARGIN = 0.1; // matches the observer's rootMargin bottom inset
  var pending = [];

  function drop(el) {
    var at = pending.indexOf(el);
    if (at !== -1) pending.splice(at, 1);
    if (io) io.unobserve(el);
  }

  function reveal(el) {
    el.classList.add('is-inview');
    drop(el);
  }

  var io = null;
  if (!reduced && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0 }
    );
  }

  function prepare(el) {
    if (el.__nsMotion) return;
    el.__nsMotion = true;
    if (el.hasAttribute('data-ns-motion-stagger')) {
      Array.prototype.forEach.call(el.children, function (child, i) {
        child.style.setProperty('--ns-motion-i', Math.min(i, 8));
      });
    }
    if (io) {
      pending.push(el);
      io.observe(el);
      bindSweep();
    } else {
      reveal(el);
    }
  }

  function observe(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(prepare);
  }

  // Reveal anything the viewport has reached or already scrolled past.
  // A collapsed element (accordion panel, inactive tab) keeps its entrance:
  // it has no box yet, so it waits for the observer to see it open.
  function sweep() {
    var limit = window.innerHeight * (1 - MARGIN);
    pending.slice().forEach(function (el) {
      if (!el.isConnected) return drop(el);
      var r = el.getBoundingClientRect();
      if (!r.width && !r.height) return;
      if (r.top < limit) reveal(el);
    });
    if (!pending.length) unbindSweep();
  }

  var queued = false;
  var bound = false;

  function onScroll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      sweep();
    });
  }

  function bindSweep() {
    if (bound || !io) return;
    bound = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  function unbindSweep() {
    if (!bound) return;
    bound = false;
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
  }

  window.NSMotion = { observe: observe, reduced: reduced, reveal: reveal };
  if (reduced || !io) {
    root.classList.remove('ns-motion-ok');
    return;
  }

  root.classList.add('ns-motion-ok');
  observe(document);

  // Anything already on screen at load reveals on the next frame, not after a scroll.
  requestAnimationFrame(sweep);

  // Theme editor and section re-renders.
  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target);
  });

  // Safety net: never leave content hidden if something goes wrong.
  window.addEventListener('load', function () {
    setTimeout(function () {
      pending.slice().forEach(function (el) {
        if (!el.isConnected) return drop(el);
        var r = el.getBoundingClientRect();
        if (!r.width && !r.height) return;
        if (r.top < window.innerHeight || r.bottom < 0) reveal(el);
      });
    }, 2500);
  });
})();
